import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({

  labelText: {
    margin: 10,
    fontSize: 16,
    color: "#003e4c",
    width: 106,
    [mobileScreen(theme)]: {
      fontSize: "12px !important",
    }
  },

});

export default styles;
